import { render, staticRenderFns } from "./TabTrigger.vue?vue&type=template&id=4da5d19d"
import script from "./TabTrigger.vue?vue&type=script&lang=ts"
export * from "./TabTrigger.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports